import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { useEffect, useState } from "react";

import { NavigationBar } from './NavigationBar';
import { Home } from './Home';
import { AuctionList } from './AuctionList';
import { Login } from './Login';
import { Register } from './Register';
import { Profile } from './Profile';
import { IProfile } from "../models/profile";
import { Activate } from "./Activate";
import { UserList } from "./UserList";
import { ResetPassword } from "./ResetPassword";
import { Info } from "./Info";
import { InfoRegular } from "@fluentui/react-icons";

export interface IPageLayoutProps {
    children: string | JSX.Element | JSX.Element[]
}

export const PageLayout = () => {
    const initialState : IProfile = { userid: 0, username: '', displayname: '', roles: [] };
    const [user, setUser] = useState<IProfile>(initialState);

    useEffect(() => {
        const saccount = localStorage.getItem('account');
        if(saccount && saccount !== ''){
            const account: IProfile = JSON.parse(saccount);
            console.log(account);
            if(account && account.userid !== 0){
                setUser(account);
            }
        }
    }, []);

    const setProfile = (profile: IProfile) => {
        setUser(profile);
        localStorage.setItem('account', JSON.stringify(profile));
    }

    return (
        <>
            <BrowserRouter>
                <NavigationBar user={user} setUser={setProfile} />
                
                <Routes>
                    <Route path="/" element={<Home user={user} />} />
                    <Route path="/adminauctions" element={<AuctionList />} />
                    <Route path="/adminusers" element={<UserList />} />
                    <Route path="/offers" element={<Home user={user} />} />
                    <Route path="/login" element={<Login setUser={setProfile} />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/activate" element={<Activate />} />
                    <Route path="/profile" element={<Profile user={user} />} />
                    <Route path="/reset" element={<ResetPassword />} />
                    <Route path="/info" element={<Info />} />
                </Routes>
                
                <div style={{marginBottom:"50px"}}></div>

                <div className="footer">
                    <div>
                        <a href="https://www.facebook.com/inpistaconilcuore" target="_blank">
                            <img src={`${process.env.PUBLIC_URL}/img/fb3.png`} style={{ width: "30px" }}  /> 
                        </a>
                    </div>
                    <div>
                        <a href="https://www.youtube.com/watch?v=vgX215reU0E" target="_blank">
                            <img src={`${process.env.PUBLIC_URL}/img/yt1.png`} style={{ width: "35px" }}  /> 
                        </a>
                    </div>
                    <div style={{fontSize: "8px", marginRight: "20px"}}>v1.4</div>
                </div>
            </BrowserRouter>
        </>
    );
}